var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FeatureFlagSwitcher',{attrs:{"flag":_vm.Feature_Flags.PORTAL_LOYALTY_REVAMP},scopedSlots:_vm._u([{key:"new",fn:function(){return [_c('LoyaltyEnhancedCollection')]},proxy:true},{key:"old",fn:function(){return [_c('LoyaltyCollection')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }